module.exports = __webpack_public_path__ + "img/western-sahara.40888fcb.png";